import React from "react";

import Dashboard from "./Blogsdisplay";
import Footer from "../Home/Footer";
import Header from "../Home/header";


function index() {
  return (
    <>
        <Header/>
        <Dashboard/>
        <Footer/>
    </>
  )
}

export default index